export default [
    {
        name: 'Convênios',
        url: '/gescon/fornecedor/convenios',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-FORN-CONV-00',
        badge: {
            variant: 'primary',
            text: 'GESCON'
        }
    }
]